module.exports = __webpack_public_path__ + "img/premio-walmart.d2be6838.png";